import WindCreekClient from '../../../src/scripts/user-account/WindCreekClient.mjs';

function getMonthName(month) {
  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  return months[month];
}

function getPaddedMonthOrDay(monthOrDay) {
  let mod = monthOrDay.toString();

  if (mod.length > 1) {
    return mod;
  }

  return mod.padStart(2, "0");
}

export default class LocalDate {
  constructor(dateString) {
    this.date = dateString ? new Date(dateString + "Z") : new Date();
    // this.date.setHours(0, 0, 0, 0);
    this.year = this.date.getFullYear();
    this.month = this.date.getMonth();
    this.day = this.date.getDate();
  }

  monthName() {
    return getMonthName(this.month);
  }

  monthYear() {
    return this.monthName() + ' ' + this.year;
  }

  paddedMonth() {
    return getPaddedMonthOrDay(this.month);
  }

  paddedDay() {
    return getPaddedMonthOrDay(this.day);
  }

  formattedDate() {
    return formattedDate(this.date);
  }

  formattedTime() {
    return this.date.toLocaleTimeString(undefined, {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  }
}

export function formattedDateString(date) {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  return `${year}-${getPaddedMonthOrDay(month)}-${getPaddedMonthOrDay(day)}`;
}

export function formattedDate(date) {
  const year = date.getFullYear();
  const month = getMonthName(date.getMonth());
  const day = date.getDate();

  return `${month} ${day}, ${year}`;
}

export function decodeHtmlEntity(htmlEntity) {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = htmlEntity;

  return textarea.value;
}

export function jackpotsQueryBody(propertyCode) {
  return {
    variables: {
      input: {
        propertyCode: propertyCode,
        leaderboardType: 'daily',
      },
    },
    query: `query getJackpotsByProperty($input: GetJackpotDetailsInput!) {
        getJackpotsByProperty(input: $input) {
          total
          jackpots {
            at
            amount
          }
        }
      }`,
  };
}

export async function getJackpotsData(propertyCode) {
  return new WindCreekClient().query(jackpotsQueryBody(propertyCode));
}
